export default "__VITE_ASSET__346812b9__"